// 活动展示与前端购买时间统一使用北京时间；后端仍须独立校验活动资格。
export const DOUBLE_ELEVEN = Object.freeze({
  enabled: true,
  path: "/11huodong",
  startAt: Date.parse("2026-11-01T00:00:00+08:00"),
  endAt: Date.parse("2026-11-12T00:00:00+08:00"),
  dateLabel: "2026.11.01 — 11.11（北京时间）",
});

// Like 双十一套餐与 One VIP 对齐；日常充值套餐独立维护。
export const RECHARGE_PACKAGES = Object.freeze(
  [
    {
      price: 3000,
      addprice: 3388,
      oldprice: 1500,
      label: "团队备图",
      badge: "绝版赠送 限时回归",
      note: "适合持续、高频的素材需求",
    },
    {
      price: 2000,
      addprice: 1688,
      oldprice: 1000,
      label: "创作优选",
      badge: "囤图底价 限时回归",
      note: "给接下来的创作多留一点余量",
    },
    {
      price: 8000,
      addprice: 9888,
      oldprice: 8000,
      label: "大额囤图",
      badge: "限时超额赠送！",
      note: "充值赠送超本金，一次备足创作所需",
    },
    {
      price: 1000,
      addprice: 588,
      oldprice: 400,
      label: "项目储备",
      badge: "抄底双十一",
    },
    {
      price: 500,
      addprice: 188,
      oldprice: 100,
      label: "常用补给",
      badge: "超额赠送 限时回归",
    },
    {
      price: 300,
      addprice: 80,
      oldprice: 50,
      label: "轻量创作",
      badge: "限时囤图福利",
    },
    {
      price: 200,
      addprice: 50,
      oldprice: 20,
      label: "日常补充",
      badge: "尝鲜体验福利",
    },
    {
      price: 100,
      addprice: 15,
      oldprice: 5,
      label: "小额充值",
      badge: "超额赠送",
    },
    {
      price: 50,
      addprice: 5,
      oldprice: 1,
      label: "按需体验",
      badge: "新手尝鲜体验包",
    },
  ].map((item) => Object.freeze(item))
);

export function getCampaignPhase(now = Date.now()) {
  if (!DOUBLE_ELEVEN.enabled) return "disabled";
  if (now < DOUBLE_ELEVEN.startAt) return "upcoming";
  return now < DOUBLE_ELEVEN.endAt ? "active" : "ended";
}

export function getCampaignCountdown(now = Date.now()) {
  const dayMs = 24 * 60 * 60 * 1000;
  const beijingOffset = 8 * 60 * 60 * 1000;
  const nextMidnight =
    (Math.floor((now + beijingOffset) / dayMs) + 1) * dayMs - beijingOffset;
  const target =
    now < DOUBLE_ELEVEN.startAt
      ? DOUBLE_ELEVEN.startAt
      : Math.min(nextMidnight, DOUBLE_ELEVEN.endAt);
  const seconds = Math.max(0, Math.ceil((target - now) / 1000));
  const pad = (value) => String(value).padStart(2, "0");
  return {
    hours: pad(Math.floor(seconds / 3600)),
    minutes: pad(Math.floor(seconds / 60) % 60),
    seconds: pad(seconds % 60),
  };
}

export function hasMemberSession(token, tempUser) {
  return (
    typeof token === "string" &&
    !["", "null", "undefined"].includes(token.trim()) &&
    tempUser !== "temp"
  );
}

export function getLoginReturnPath(redirect) {
  return redirect === DOUBLE_ELEVEN.path
    ? DOUBLE_ELEVEN.path
    : "/materialDownload";
}

export function getLoginRoute(currentPath) {
  return currentPath === DOUBLE_ELEVEN.path
    ? { path: "/login", query: { redirect: DOUBLE_ELEVEN.path } }
    : { path: "/login" };
}
